import React, {Component, forwardRef} from 'react';
import { connect } from 'react-redux';
import {isEmpty} from 'lodash';
import MobileNumber from '../form/MobileNumber';
import Input from '../form/input';
import {Site,Location,Zone} from '../../utility/Masterdata';

const upInitialState = () => {
    return {
        zones:[],
        locations:[],
        sites:[],
    }
}

let upGlobalState = {};

class UserProfile extends Component{

    constructor(props){
        super(props);
        this.state = !isEmpty(upGlobalState) ? upGlobalState : upInitialState();

        this.locationMas = Location.getInstance();
        this.siteMas = Site.getInstance();
        this.ZoneMas = Zone.getInstance();
        this.checkUser = this.checkUser.bind(this);

        if(!isEmpty(upGlobalState)){
            this.ZoneMas.set(upGlobalState.zones);
            this.locationMas.set(upGlobalState.locations);
            this.siteMas.set(upGlobalState.sites);
        }

        this.getMasterData = this.getMasterData.bind(this);
        this.handleLocationDetails = this.handleLocationDetails.bind(this);
    }

    /**
     * handle the response of zone, location, site
     *
     * @param object - props
     */
    handleLocationDetails(props){
        this.ZoneMas.set(props.zoneTypeProfile);
        this.locationMas.set(props.locationTypeProfile);
        this.siteMas.set(props.siteSelectProfile);

        this.setState({
            zones:this.ZoneMas.getAll(),
            locations:this.locationMas.getAll(),
            sites:this.siteMas.getAll()
        });
    }

    checkUser(){
      return !this.props.auth.isTclAdminUser() && !this.props.auth.isCustomerAdmin() && !this.props.auth.isProjectAdmin();
    }

    componentWillReceiveProps(props){
        this.handleLocationDetails(props);
    }

    componentWillUnmount() {
        // Remember state for the next mount
        upGlobalState = this.state;
    }

    /**
     * Get the location, zone, site data at first time
     *
     * @param object - currentState
     */
    getMasterData(currentState){
        // User zone,location,site details only required for users belongs to direct customers
        // Not for customer admin, super admin and users belongs to super admin
        // that's why we check here condition to dispatch actions
        // when user not customer admin & super admin and users belongs to super admin
        if(!this.props.auth.isTclAdminUser() && !this.props.auth.isCustomerAdmin()){
            // Dispatch other details action
            if(isEmpty(upGlobalState.zones)){
                //this.props.dispatch(masterData.zoneType({customerId:currentState.customerId,type:ZONE_TYPE_PROFILE}));
            }

            if(isEmpty(upGlobalState.locations)){
                //this.props.dispatch(masterData.locationType({zoneId:currentState.zoneId,type:LOCATION_TYPE_PROFILE}));
            }

            if(isEmpty(upGlobalState.sites)){
                //this.props.dispatch(masterData.siteSelect({siteId:currentState.siteId,type:SITESELECT_PROFILE}));
            }
        }
    }

    render(){
          if(localStorage.getItem('language')=="ar" && this.props.state.fields.userCountryCode==="" ){
            this.props.state.fields.userCountryCode="+966"
        }else
        if(localStorage.getItem('language')=="en" && this.props.state.fields.userCountryCode==="" ){
            this.props.state.fields.userCountryCode="+91"
        }
        return  <div className="profilepersonaldtails profiledtailsset">
                    <h2>{this.props.locale.common.personal_information}</h2>
                    {!this.props.auth.isTclAdminUser() && !this.props.auth.isProjectAdmin() &&
                        <div className="form-group">
                            <label>{this.props.locale.customer.form.utility_type} {this.props.state.fields.utilityName}</label>
                           
                        </div>
                    }
                    <br />
                    <Input {...this.props}
                    fieldName = {'firstName'}
                    value={this.props.state.fields.firstName}
                    labelName={this.props.locale.user.first_name}
                    validation={true}
                    />
                    <Input {...this.props}
                        fieldName = {'middleName'}
                        value={this.props.state.fields.middleName}
                        labelName={this.props.locale.user.middle_name}
                        validation={false}
                        />
                    <Input {...this.props}
                        fieldName = {'lastName'}
                        value={this.props.state.fields.lastName}
                        labelName={this.props.locale.user.last_name}
                        validation={false}
                        />
                    {/* <div className="form-group">
                        <label>{this.props.locale.user.email_id}</label>
                        <label>{this.props.state.fields.emailId}</label>
                    </div> */}
                    <MobileNumber {...this.props}
                              codeFieldName = {'userCountryCode'}
                              codeValue = {this.props.state.fields.userCountryCode}
                              fieldName = {'mobileNumber'}
                              value={this.props.state.fields.mobileNumber}
                              labelName={this.props.locale.user.mobile_number}
                              validation={false}
                          />

                    {/* <Input {...this.props}
                        dataType={"number"}
                        onChange={this.props.form.handleIntegerWithDashChange}
                        fieldName = {'phoneNumber'}
                        value={this.props.state.fields.phoneNumber || ''}
                        labelName={this.props.locale.user.phone_number}
                        validation={true}
                        maxLength={12}
                    /> */}
                    { this.checkUser() &&
                        <div className="form-group">
                            <label>{this.props.locale.zone.zone} {this.ZoneMas.getNameById(this.props.state.fields.zoneId)}</label>
                          
                        </div>
                    }
                    {this.checkUser() &&
                        <div className="form-group">
                            <label>{this.props.locale.user.location} {this.locationMas.getNameById(this.props.state.fields.siteId)}</label>
                           
                        </div>
                    }
                    {this.checkUser() &&
                        <div className="form-group">
                            <label>{this.props.locale.user.site} {this.siteMas.getNameById(this.props.state.fields.locationId)}</label>
                           
                        </div>
                    }
                </div>
    }
}

const mapStateToProps = (state) => ({
    siteSelectProfile: state.siteSelectProfile,
    locationTypeProfile: state.locationTypeProfile,
    zoneTypeProfile: state.zoneTypeProfile
});
  
  const UserProfileWithRef = forwardRef((props, ref) => (
    <UserProfile {...props} ref={ref} />
  ));
  
  export default connect(mapStateToProps, null, null, { forwardRef: true })(
    UserProfileWithRef
  )
